import React, { useState, useEffect } from 'react';
import Logo from '../UI/Logo';
import './Header.css';

interface HeaderProps {
  transparent?: boolean;
}

const Header: React.FC<HeaderProps> = ({ transparent = false }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Split navigation items into left and right sides
  const leftNavItems = [
    { label: 'Преимущества', href: '#why' },
    { label: 'Демо', href: '#demo' }
  ];

  const rightNavItems = [
    { label: 'Выгода', href: '#benefits' },
    { label: 'Тарифы', href: '#pricing' },
    { label: 'Контакты', href: '#contact' }
  ];

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''} ${transparent ? 'transparent' : ''}`}>
      <div className="container">
        <div className="header-content">
          {/* Left Navigation */}
          <nav className={`nav nav-left ${isMobileMenuOpen ? 'open' : ''}`}>
            {leftNavItems.map((item, index) => (
              <a 
                key={`left-${index}`} 
                href={item.href} 
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.label}
              </a>
            ))}
          </nav>
          
          {/* Logo in Center */}
          <a href="/" className="logo-link">
            <Logo imagePath="/logo_kvadro_text.png" />
          </a>
          
          {/* Right Navigation */}
          <nav className={`nav nav-right ${isMobileMenuOpen ? 'open' : ''}`}>
            {rightNavItems.map((item, index) => (
              <a 
                key={`right-${index}`} 
                href={item.href} 
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* Mobile Menu Toggle Button */}
          <button 
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'open' : ''}`} 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;